export default {
  // Navigation
  'nav.home': 'Inicio',
  'nav.about': 'Quiénes Somos',
  'nav.companies': 'Megatendencias',
  'nav.gallery': 'Galería',
  'nav.news': 'Noticias',
  'nav.careers': 'Carreras',
  'nav.locations': 'Ubicaciones',
  'nav.faq': 'FAQ',
  'nav.contact': 'Contacto',

  // Hero Section
  'hero.subtitle': 'Holding Empresarial Multinacional',
  'hero.title': 'INKAVIDA CORPORATION',
  'hero.description': 'Ecosistema de 6 empresas líderes enfocado en crecimiento sostenible e innovación.',
  'hero.cta': 'Nuestras Empresas',

  // Companies Section
  'companies.subtitle': 'Nuestro Ecosistema',
  'companies.title': 'MEGATENDENCIAS',
  'companies.megatendencias': 'Megatendencias',
  'companies.cta': 'Ver Más',
  'companies.inkavida_global.name': 'Inkavida Global',
  'companies.inkavida_global.description': 'Empresa líder en productos naturales y bienestar, comprometida con la salud integral de nuestros clientes.',
  'companies.club_inkavida.name': 'Club Inkavida',
  'companies.club_inkavida.description': 'Comunidad exclusiva de membresías que ofrece beneficios únicos y programas de fidelización para nuestros socios.',
  'companies.inmobiliaria_inkavida.name': 'Inmobiliaria Inkavida',
  'companies.inmobiliaria_inkavida.description': 'Desarrollo de proyectos inmobiliarios innovadores, inversiones estratégicas y transformación urbana sostenible.',
  'companies.hipermercados_inkavida.name': 'Hipermercados Inkavida',
  'companies.hipermercados_inkavida.description': 'Cadena de retail en expansión con enfoque en comercio mayorista y minorista de alta calidad.',
  'companies.inversiones_inkavida.name': 'Inversiones Inkavida',
  'companies.inversiones_inkavida.description': 'División especializada en expansión financiera, capitalización estratégica y desarrollo de proyectos de alto impacto.',
  'companies.super_inka.name': 'Super Inka',
  'companies.super_inka.description': 'Planta de manufactura y desarrollo de productos con tecnología de punta y estándares internacionales de calidad.',

  // Philosophy Section
  'philosophy.subtitle': 'Nuestro Ecosistema',
  'philosophy.title': 'Nuestra Filosofía',
  'philosophy.god.title': 'DIOS',
  'philosophy.god.description': 'Reconocemos a Dios como el fundamento de nuestros valores y principios, guiando nuestras decisiones con integridad, honestidad y respeto hacia todos.',
  'philosophy.family.title': 'FAMILIA',
  'philosophy.family.description': 'Valoramos la familia como el núcleo de nuestra sociedad, promoviendo el bienestar, la unión y el crecimiento personal de cada miembro de nuestra comunidad.',
  'philosophy.business.title': 'NEGOCIO',
  'philosophy.business.description': 'Desarrollamos negocios sostenibles y prósperos que generen valor para todos nuestros stakeholders, contribuyendo al desarrollo económico y social.',

  // Business Model Section
  'business.subtitle': 'Estrategia Corporativa',
  'business.title': 'Integración Empresarial Estratégica',
  'business.description': 'Diversificación inteligente y sinergia operativa para maximizar el valor de nuestro ecosistema empresarial.',
  'business.diversification.title': 'Diversificación Estratégica',
  'business.diversification.description': 'Presencia consolidada en múltiples sectores económicos que garantizan estabilidad y crecimiento sostenido en el mercado latinoamericano.',
  'business.synergy.title': 'Sinergia Corporativa',
  'business.synergy.description': 'Integración operativa que potencia las capacidades de cada empresa, optimizando recursos y maximizando resultados del grupo.',
  'business.expansion.title': 'Expansión Internacional',
  'business.expansion.description': 'Visión global con proyección de crecimiento en mercados estratégicos de América Latina y expansión planificada a nuevos territorios.',
  'business.innovation.title': 'Innovación Continua',
  'business.innovation.description': 'Inversión constante en tecnología, desarrollo e investigación para mantener el liderazgo competitivo en cada sector.',
  'business.vision.title': 'Visión Integral',
  'business.vision.description': 'Cobertura completa del ciclo de valor en cada industria donde participamos',
  'business.commitment.title': 'Compromiso',
  'business.commitment.description': 'Dedicación total a la excelencia operativa y satisfacción de nuestros clientes',
  'business.growth.title': 'Crecimiento',
  'business.growth.description': 'Potencial ilimitado de expansión y desarrollo en nuevos mercados y sectores',

  // Impact Section
  'impact.title': 'Impacto y Responsabilidad',
  'impact.description': 'Generamos valor sostenible para nuestros stakeholders y las comunidades donde operamos',
  'impact.companies.title': 'Empresas Consolidadas',
  'impact.companies.description': 'Diversificación estratégica en sectores clave de la economía',
  'impact.experience.title': 'Años de Trayectoria',
  'impact.experience.description': 'Experiencia y solidez en el mercado latinoamericano',
  'impact.jobs.title': 'Empleos Generados',
  'impact.jobs.description': 'Contribución al desarrollo económico y social de la región',

  // CTA Section
  'cta.title': 'Únete al Ecosistema\nIVG CORP',
  'cta.description': 'Descubre oportunidades de colaboración y crecimiento dentro de nuestro holding empresarial',
  'cta.contact': 'Contactar Ahora',
  'cta.opportunities': 'Ver Oportunidades',

  // Events Section
  'events.title': 'Nuestros Eventos',

  // Footer
  'footer.description': 'Holding empresarial multinacional comprometido con la excelencia y la innovación.',
  'footer.companies': 'MEGATENDENCIAS',
  'footer.corporate': 'Corporativo',
  'footer.about': 'Quiénes Somos',
  'footer.megatrends': 'Megatendencias',
  'footer.opportunity': 'Oportunidad',
  'footer.resources': 'Recursos',
  'footer.faq': 'FAQ',
  'footer.support': 'Soporte',
  'footer.contact': 'Contacto',
  'footer.address': 'Dirección',
  'footer.phone': 'Teléfono',
  'footer.whatsapp': 'WhatsApp',
  'footer.email': 'Email',
  'footer.complaints_book': 'Libro de Reclamaciones',
  'footer.rights': '© 2026 IVG CORP. Todos los derechos reservados.',

  // Libro de Reclamaciones
  'complaints.hero.title': 'Libro de Reclamaciones',
  'complaints.hero.subtitle': 'Tu opinión nos importa',
  'complaints.hero.description': 'Estamos comprometidos con la excelencia en el servicio. Registra tu reclamo o queja aquí.',
  'complaints.form.title': 'Registrar Reclamo',
  'complaints.form.name': 'Nombre Completo',
  'complaints.form.email': 'Correo Electrónico',
  'complaints.form.phone': 'Teléfono',
  'complaints.form.document': 'Documento de Identidad',
  'complaints.form.type': 'Tipo',
  'complaints.form.type_select': 'Selecciona el tipo',
  'complaints.form.type_complaint': 'Reclamo',
  'complaints.form.type_claim': 'Queja',
  'complaints.form.description': 'Descripción',
  'complaints.form.description_placeholder': 'Describe tu reclamo o queja detalladamente...',
  'complaints.form.submit': 'Enviar Reclamo',
  'complaints.form.sending': 'Enviando...',
  'complaints.info.title': 'Información Legal',
  'complaints.info.description': 'De acuerdo con el Código de Protección y Defensa del Consumidor, tienes derecho a presentar tu reclamo o queja.',
  'complaints.info.complaint': 'Reclamo: Disconformidad relacionada a los productos o servicios.',
  'complaints.info.claim': 'Queja: Disconformidad no relacionada a los productos o servicios, o malestar respecto a la atención.',
  'complaints.info.response': 'Recibirás una respuesta en un plazo máximo de 15 días hábiles.',
};